export default __webpack_public_path__ + "static/ISO9001-b7f2a79cf550c94f7b94de27cd091d22.png";